import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  faTimes,
  faSave,
  faTrash,
  faCheck } from
"@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GetAdminService from "../../../services/admin/GetAdminService";
import swal from "sweetalert";
import { singleState } from "../../../constants/data";
import "./School.css";
import "../AdminPages.css";
import { Modal, ModalBody } from "reactstrap";
import CustomLoader from "../../customLoader/CustomLoader";

const DeleteModal = ({ isOpen, setIsOpen, fun1 }) => {
  return (
    <Fragment>
      <Modal isOpen={isOpen} centered={true}>
        <ModalBody>
          <div style={{ textAlign: "center" }}>
            <p>Are you sure you want to delete?</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={fun1}
                style={{
                  backgroundColor: "#009900",
                  color: "white",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginRight: "20px",
                  borderRadius: "5px"
                }}>
                
                <FontAwesomeIcon
                  style={{ margin: "0 5px" }}
                  color="white"
                  icon={faCheck} />
                
                Ok
              </button>
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  backgroundColor: "#efefef",
                  color: "black",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginLeft: "20px",
                  borderRadius: "5px"
                }}>
                
                <FontAwesomeIcon style={{ margin: "0 5px" }} icon={faTimes} />
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>);

};

const NewSchool = ({ setOpenNewSchool, modify, schoolId }) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [schoolName, setSchoolName] = useState();
  const [schoolCode, setSchoolCode] = useState();
  const [addressName, setAddressName] = useState();
  const districtNameRef = useRef();
  const [cityName, setCityName] = useState();
  const timeoutRef = useRef();
  const [, setPageData] = useState();
  const [districtID, setDistrictID] = useState();
  const [districtNameLoading, setDistrictNameLoading] = useState(false);
  const [districtNameList, setDistrictNameList] = useState();
  const [zip, setZip] = useState();
  const [isHidden, setIsHidden] = useState(true);
  const [isMiddle, setIsMiddle] = useState(false);
  const [, setIsDeleted] = useState(false);
  const [isProgress, setIsProgress] = useState(false);
  const [districtName, setDistrictName] = useState();
  const stateFromData = JSON.parse(JSON.stringify(singleState));
  const [selectedState, setSelectedState] = useState();
  const [showDistrictNameContainer, setShowDistrictNameContainer] = useState(
    false
  );

  const deleteSchool = () => {
    setIsDeleted(true);
    //  let obj = {
    //   address: modify?.address?.address,
    //   ceeb_code: modify.ceeb_code,
    //   city: modify?.address?.city,
    //   codename: modify?.codename,
    //   // email_count: modify.email_count,
    //   id: schoolId,
    //   isHidden: modify.isHidden,
    //   isSigned: modify.isSigned,
    //   is_deleted: true,
    //   is_middle_school: modify.is_middle_school,
    //   // mobile_count: modify.mobile_count,
    //   name: modify.name,
    //   // resource_uri: modify.resource_uri,
    //   sso_enable: modify.sso_enable,
    //   state: modify?.address?.state,
    //   student_progress_enable: modify.student_progress_enable,
    //   upload_csv: modify.upload_csv,
    //   zip_code: modify?.address?.zip_code,
    // };

    //   name: modify?.name,
    //   codename: modify?.codename,
    //   address: {
    //     address:modify?.address,
    //     city: modify?.city,
    //     state: modify?.state,
    //     zip_code: modify?.zip,
    //   },
    //   is_middle_school: modify?.is_middle_school,
    //   student_progress_enable: modify?.student_progress_enable,
    //   isHidden: modify?.isHidden,
    // };
    GetAdminService.getDeleteSchool(schoolId)
    .then((_data) => {
      swal({
        title: "Successfully",
        text: "School deleted successfully",
        icon: "success",
        dangerMode: true,
        buttons: {
          ok: true
        },
        closeOnClickOutside: true
      });
    })
    .catch((error) => {
      swal({
        title: "Oops!!",
        text: error.response.data.message || "Something went wrong",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true
        },
        closeOnClickOutside: true
      });
    });
    setOpenDeleteModal(false);
    setOpenNewSchool(false);
  };

  const getDistrictsList = (value) => {
    setDistrictNameLoading(true);
    GetAdminService.getDistrictsList(value)
    .then((data) => {
      setDistrictNameList(data?.data?.objects);
      setDistrictNameLoading(false);
      setShowDistrictNameContainer(true);
    })
    .catch((_error) => {
      setDistrictNameLoading(false);
    });
  };

  const handleDistrictName = () => {
    clearTimeout(timeoutRef.current);
    setDistrictName(districtNameRef.current.value);
    if (!districtNameRef.current.value) {
      setShowDistrictNameContainer(false);
      setDistrictNameList([]);
      setPageData([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getDistrictsList(districtNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedDistrictName = (item) => {
    setDistrictID(item?.id);
    setDistrictNameList([item]);
    setShowDistrictNameContainer(false);
    setDistrictName(item.name);
    // getDistrictPage(item?.id);
  };

  const handleSchoolName = (event) => {
    const newValue = event.target.value;
    setSchoolName(newValue);
    if (!modify) {
      setSchoolCode(newValue.toLowerCase().replace(/\s+/g, "-"));
    } else {
      setSchoolCode(modify?.codename);
    }
  };

  const handleCheckboxHidden = () => {
    setIsHidden((prev) => !prev);
  };

  const handleCheckboxMiddle = () => {
    setIsMiddle((prev) => !prev);
  };

  const handleCheckboxProgress = () => {
    setIsProgress((prev) => !prev);
  };

  // const handleSelectState = (event) => {
  //   setSelectedState(event.target.value);
  // };

  const handleAddressName = (event) => {
    setAddressName(event.target.value);
  };

  const handleCityName = (event) => {
    setCityName(event.target.value);
  };

  const handleZip = (event) => {
    if (event.target.value.length <= 6) {
      setZip(event.target.value);
    }
  };

  useEffect(() => {
    if (modify) {
      setSchoolName(modify?.name);
      setSchoolCode(modify?.codename);
      setAddressName(modify.address?.address);
      setCityName(modify?.address?.city);
      setZip(modify?.address?.zip_code);
      setSelectedState(modify?.address?.state);
      setDistrictName(modify?.district_name);
      setDistrictID(modify?.district);
      setIsProgress(modify?.student_progress_enable);
      setIsMiddle(modify?.is_middle_school);
      setIsHidden(modify?.isHidden);
    }
  }, [modify]);

  const saveSchool = () => {
    // let obj;
    // if (isMiddle === true) {
    //   obj = {
    //     name: schoolName,
    //     codename: schoolCode,
    //     address: addressName,
    //     city: cityName,
    //     zip_code: zip,
    //     state: selectedState,
    //     is_middle_school: isMiddle,
    //     isHidden: isHidden,
    //   };
    // } else if (isProgress === true) {
    //   obj = {
    //     name: schoolName,
    //     codename: schoolCode,
    //     address: addressName,
    //     city: cityName,
    //     zip_code: zip,
    //     state: selectedState,
    //     student_progress_enable: isProgress,
    //     isHidden: isHidden,
    //   };
    // } else if (isMiddle === false || isProgress === false) {
    //   obj = {
    //     name: schoolName,
    //     codename: schoolCode,
    //     address: addressName,
    //     city: cityName,
    //     zip_code: zip,
    //     state: selectedState,
    //     isHidden: isHidden,
    //   };
    // }

    let obj = {
      name: schoolName,
      codename: schoolCode,
      address: {
        address: addressName,
        city: cityName,
        state: 'California',
        zip_code: zip
      },
      district: {
        id: districtID,
        name: districtName
      },
      is_middle_school: isMiddle,
      student_progress_enable: isProgress,
      isHidden: isHidden
    };

    GetAdminService.createSchool(obj)
    .then((_data) => {
      swal({
        title: "Successfully",
        text: "New school created successfully",
        icon: "success",
        dangerMode: true,
        buttons: {
          ok: true
        },
        closeOnClickOutside: true
      });
    })
    .catch((error) => {
      swal({
        title: "Oops!!",
        text: error.response.data.message,
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true
        },
        closeOnClickOutside: true
      });
    });
    setOpenNewSchool(false);
  };

  const updateSchool = () => {
    let obj = {
      name: schoolName,
      codename: schoolCode,
      address: {
        address: addressName,
        city: cityName,
        state: selectedState,
        zip_code: zip
      },
      district: districtID,
      // {
      //   id:  || modify?.district?.id,
      //   name: districtName,
      // },
      is_middle_school: isMiddle,
      student_progress_enable: isProgress,
      isHidden: isHidden
    };

    GetAdminService.updateSchool(obj, schoolId)
    .then((_data) => {
      swal({
        title: "Successfully",
        text: "School updated successfully",
        icon: "success",
        dangerMode: true,
        buttons: {
          ok: true
        },
        closeOnClickOutside: true
      });
    })
    .catch((error) => {
      swal({
        title: "Oops!!",
        text: error.response.data.message,
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true
        },
        closeOnClickOutside: true
      });
    });
    setOpenNewSchool(false);
  };

  return (
    <Fragment>
      <div className="goal-full-container">
        <div className="drawer-header">
          <h3 className="drawer-title">
            {modify ? "Modify School" : "New School"}
          </h3>
          <button
            type="button"
            className="drawer-close-btn"
            onClick={() => setOpenNewSchool(false)}
            aria-label="Close">
            
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="drawer-section">
          <div className="drawer-form-row">
            <div className="form-label-col">
              School Name
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="School Name"
                value={schoolName}
                onChange={handleSchoolName}
                autoComplete="off" />
              
            </div>
          </div>

          <div className="drawer-form-row">
            <div className="form-label-col">
              ID / Code
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="School Code Name"
                value={schoolCode}
                onChange={handleSchoolName}
                autoComplete="off"
                disabled={!!modify} />
              
            </div>
          </div>

          <div className="drawer-form-row">
            <div className="form-label-col">Address</div>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="Address First Line"
                value={addressName}
                onChange={handleAddressName}
                autoComplete="off" />
              
            </div>
          </div>

          <div className="drawer-form-row">
            <div className="form-label-col">City</div>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="City"
                value={cityName}
                onChange={handleCityName}
                autoComplete="off" />
              
            </div>
          </div>

          <div className="drawer-form-row">
            <div className="form-label-col">District</div>
            <div className="form-field-col" style={{ position: "relative" }}>
              <input
                ref={districtNameRef}
                type="text"
                placeholder="District Name"
                value={districtName}
                onChange={handleDistrictName}
                autoComplete="off" />
              
              {showDistrictNameContainer &&
              <ul className="drawer-autocomplete">
                  {districtNameLoading && <CustomLoader />}
                  {districtNameList?.length > 0 &&
                districtNameList.map((item, index) =>
                <li
                  onClick={() => handleSelectedDistrictName(item)}
                  key={index}>
                  
                        {item.name}
                      </li>
                )}
                </ul>}
              
            </div>
          </div>

          <div className="drawer-form-row">
            <div className="form-label-col">State</div>
            <div className="form-field-col">
              {modify ?
              <input
                type="text"
                autoComplete="off"
                value={selectedState}
                disabled /> :


              <select disabled value={selectedState}>
                  {stateFromData?.map((item, index) =>
                <option key={index} value={item?.name}>
                      {item?.name}
                    </option>
                )}
                </select>}
              
            </div>
          </div>

          <div className="drawer-form-row">
            <div className="form-label-col">Zip Code</div>
            <div className="form-field-col">
              <input
                type="number"
                placeholder="Zip Code"
                value={zip}
                onChange={handleZip}
                autoComplete="off" />
              
            </div>
          </div>
        </div>

        <div className="drawer-section">
          <label className="drawer-checkbox-row">
            <input
              type="checkbox"
              checked={isProgress}
              onChange={handleCheckboxProgress} />
            
            <span>Enable Student Progress for School</span>
          </label>
          <label className="drawer-checkbox-row">
            <input
              type="checkbox"
              checked={isMiddle}
              onChange={handleCheckboxMiddle} />
            
            <span>Enable as Middle School</span>
          </label>
          <label className="drawer-checkbox-row">
            <input
              type="checkbox"
              checked={isHidden}
              onChange={handleCheckboxHidden} />
            
            <span>Hidden</span>
          </label>
        </div>

        <div className="drawer-footer">
          {modify &&
          <button
            type="button"
            className="drawer-btn-delete"
            onClick={() => setOpenDeleteModal(true)}>
            
              <FontAwesomeIcon icon={faTrash} />
              Delete
            </button>}
          
          <button
            type="button"
            className="drawer-btn-save"
            onClick={modify ? updateSchool : saveSchool}
            disabled={!schoolName}>
            
            <FontAwesomeIcon icon={faSave} />
            Save
          </button>
        </div>

        {openDeleteModal &&
        <DeleteModal
          isOpen={openDeleteModal}
          setIsOpen={setOpenDeleteModal}
          fun1={deleteSchool} />}

        
      </div>
    </Fragment>);

};
export default NewSchool;